import { useState, useEffect } from "react";
import { loadPurchaseIndentNumber } from "../services/purchaseIndentService";

const usePurchaseIndentNumber = (editID) => {
    const [purchaseIndentNumber, setPurchaseIndentNumber] = useState([]);
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);

    // Fetch department data
    const fetchPurchaseIndentNumber = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadPurchaseIndentNumber(para);
            if (data && data.length > 0) {
                setPurchaseIndentNumber(data[0].purchase_indent_number);

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchPurchaseIndentNumber();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadPurchaseIndentNumberByID = async (selectedID) => {
        await setPurchaseIndentNumber(selectedID);
    };

    return {
        purchaseIndentNumber,
        setPurchaseIndentNumber,
        loadPurchaseIndentNumberByID,
    };
};

export default usePurchaseIndentNumber;
